<template>
  <v-toolbar dark color="#2C3A47">
    <v-layout>
      <v-flex xs6 sm6 md4>
        <v-layout align-center justify-start>
          <v-icon @click="onBack" class="icon-arrow-left">fa-solid fa-lg
            fa-arrow-left
          </v-icon>
          <v-btn icon ma-1 style="cursor: default">
            <v-icon :size="sizeIcon" :style="`font-size: ${sizeIcon}px;`">{{
                icon
              }}
            </v-icon>
          </v-btn>
          <!--          click-icon-->
          <v-toolbar-title class="subheading ml-1">{{ title }}</v-toolbar-title>
          <slot name="sub-title"></slot>
        </v-layout>
      </v-flex>
      <v-flex xs6 sm6 md8>
        <v-layout align-center justify-end>
          <slot name="end-content"></slot>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-toolbar>
</template>

<script>

export default {
  name: 'ToolbarAdmin',
  props: {
    icon: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    sizeIcon: {
      required: false,
      type: String,
      default: '20'
    }
  },
  methods: {
    onBack() {
      this.$emit('click-back');
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped lang="stylus">
 .icon-arrow-left
   font-size: 21px;
   color: #ff9800;

</style>